import { render, staticRenderFns } from "./SessionDetailsDialog.vue?vue&type=template&id=1c37d40c&scoped=true"
import script from "./SessionDetailsDialog.vue?vue&type=script&lang=js"
export * from "./SessionDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./SessionDetailsDialog.vue?vue&type=style&index=0&id=1c37d40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37d40c",
  null
  
)

export default component.exports